export const Marquee = ({ words, tone = "light" }) => {
  const dark = tone === "dark";
  const row = (
    <div className="flex items-center shrink-0" aria-hidden="true">
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display text-5xl sm:text-6xl lg:text-7xl whitespace-nowrap px-6 sm:px-10 ${i % 2 ? "italic" : ""} ${dark ? "text-white" : "text-[var(--ink)]"}`}>{w}</span>
          <span className={`w-6 h-6 sm:w-8 sm:h-8 shrink-0 ${["petal-bl bg-[var(--yellow)]", "petal-tr bg-[var(--coral)]", "petal-br bg-[var(--blue)]"][i % 3]}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative overflow-hidden py-10 sm:py-14 ${dark ? "bg-[var(--green-night)]" : "border-y border-[var(--line)]"}`} data-testid="editorial-marquee">
      <p className="sr-only">{words.join(" · ")}</p>
      <div className="marquee">{row}{row}</div>
    </div>
  );
};
